<template >
  <div class="s-barra">
    <div class="text-center">
      <a class="s-icono-base mt-3" style="border-radius: 6px;" target="_blank"
        href="https://api.whatsapp.com/send?phone=593969721145">
        <svg  xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" style="fill: #fff;margin-top: -3px;"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 16h-2v-2h2v2zm.976-4.885c-.196.158-.385.309-.535.459-.408.407-.44.777-.441.793v.133h-2v-.167c0-.118.029-1.177 1.026-2.174.195-.195.437-.393.691-.599.734-.595 1.216-1.029 1.216-1.627a1.934 1.934 0 0 0-3.867.001h-2C8.066 7.765 9.831 6 12 6s3.934 1.765 3.934 3.934c0 1.597-1.179 2.55-1.958 3.181z"></path></svg>
      </a>
      <hr class="s-hr-color" style="margin: 1rem 0;">
      <span class="s-icono-base" style="background-color: #9dcf00;" @click="isDevs= true">
        <svg style="fill: #fff;margin-top: -3px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263"></path></svg>
      </span>
      <span class="s-icono-base mt-3 s-iconos-opaco" @click="isDevs= true">
        <svg style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M4 18h2v4.081L11.101 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2z"></path><path d="M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"></path></svg>
      </span>
      <span class="s-icono-base mt-3 s-iconos-opaco">
        <svg style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"></path><path d="M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z"></path></svg>
      </span>
      <hr class="s-hr-color" style="margin: 1rem 0;">
      <span class="s-icono-base" @click="isDevs= true" style="background-color: #d77c64 !important;color:#fff !important;">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="fill: #fff;margin-top: -3px;"><path d="M8.648 14.711 11.997 18l3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.219-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069z"></path><path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path></svg>
      </span>
      <div  v-if="$store.getters.user.roles.includes('Admin')">
        <span class="s-icono-base mt-3 s-iconos-opaco " @click="isFech = true">
          <svg style="fill: var(--menu-text-color);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" ><path d="M20.978 13.21a1 1 0 0 0-.396-1.024l-14-10a.999.999 0 0 0-1.575.931l2 17a1 1 0 0 0 1.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 0 0 .782-.769z"></path></svg>
        </span>
      </div>
    </div>
  </div>
  <section v-if="isFech">
    <Suspense>
      <template #default>
        <FechasView @closed="isFech = false" />
      </template>
      <template #fallback>
        <ProgressBar />
      </template>
    </Suspense>
  </section>
  <section v-if="isDevs">
    <Suspense>
      <template #default>
        <Developers @closed="isDevs = false" />
      </template>
      <template #fallback>
        <ProgressBar />
      </template>
    </Suspense>
  </section>
</template>
<script setup>
import ProgressBar from '@/shared/ProgressBar.vue';
import { defineAsyncComponent, ref } from 'vue'

const isFech = ref(false)
const isDevs = ref(false)
const FechasView = defineAsyncComponent(() =>
  import('../modules/setting/tools/FechasView.vue')
)
const Developers = defineAsyncComponent(() =>
  import('../modules/integraciones/Developers.vue')
)
</script>
<style>
.s-barra {
  width: 55px;
  position: fixed;
  top: 56px;
  height: 100%;
  /* z-index: 9999; */
  right: 0px;
  transition: none 0s ease 0s;
  border-left: 1px solid var(--borde-menu-lateral);
}</style>